import debounce from 'lodash/debounce'
import { logger } from '../../logger/logger'
import { LogActionType } from 'api/logs/log-action-type'

export const logVolumeChange = debounce(
  (value: number) => logger.log(LogActionType.PlaybackVolumeChange, { value }),
  1000,
)
